module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "id": _vm.id,
      "dark": _vm.dark,
      "color": _vm.color == 'secondary' ? 'blue-grey darken-4' : _vm.color,
      "disabled": _vm.disabled
    }
  }, [_vm._v(_vm._s(_vm.label))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d37fb21"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/actionButton/ActionButton.vue
// module id = 1831
// module chunks = 0